export const data = (name: string) => {
    const dataEl = document.getElementById("metachat-data");
    if (!dataEl) {
        throw new Error("data element not found");
    }
    return {
        raw: dataEl.dataset[name] || "",
        asJson: () => JSON.parse(dataEl.dataset[name] || "{}"),
        asInt: () => parseInt(dataEl.dataset[name] || "0"),
        asBool: () => (dataEl.dataset[name] === '1')
    };
}
